export default __webpack_public_path__ + "static/media/nftop.925623d8.gif";